import React from 'react'
import { Route, Switch } from 'react-router-dom'
import ErrorBoundary from 'components/ErrorBoundary'
import RouteEditor from './routes/editor'
import RouteVersion from './routes/version'

const App = () => (
  <ErrorBoundary>
    <Switch>
      <Route exact path="/" component={RouteEditor} />
      <Route exact path="/version" component={RouteVersion} />
    </Switch>
  </ErrorBoundary>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js